import { defineMessages } from "react-intl";

/** Row subtitle for each listing type the picker offers. */
const LISTING_TYPE_LABELS = defineMessages({
  Event: {
    defaultMessage: "Event listing",
    id: "host_hub.date_based_pricing_dialog.event_listing",
  },
  "Off-Site": {
    defaultMessage: "Meeting listing",
    id: "host_hub.date_based_pricing_dialog.offsite_listing",
  },
  Production: {
    defaultMessage: "Production listing",
    id: "host_hub.date_based_pricing_dialog.production_listing",
  },
});

export { LISTING_TYPE_LABELS };
